(ns app.front.view.workspace.phase-errors
  (:require [app.front.ui.error-list :as ui-error-list]
            [app.front.view.workspace.action-subs :as action-subs]
            [core.front.event :refer [<sub]]))

(defn errors
  "A standalone error section for phases without the progress view."
  [tr process-sub]
  (let [errors (<sub [::action-subs/all-errors process-sub])]
    (when (not-empty errors)
      [:div.flex.flex-col.lg:flex-row.justify-between.mt-2.pl-8
       [:p (tr [:application/incomplete-tasks-exist])]
       [:div#error-list.flex.flex-col
        [ui-error-list/signal-error-list tr errors]]])))
